module.exports = __webpack_public_path__ + "static/v10-d9348e1495f2b845278ece0ab379c60a.jpg";